import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/huBei/insure_mall@2x.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7f0369a6")

_pushScopeId("data-v-7f0369a6")
const _hoisted_1 = { class: "service-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})